module.exports = __webpack_public_path__ + "img/wallet-money.156cdcd3.svg";